import { useQuery } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { ITemplate } from 'entities/template/template';

export const useTemplateQuery = (siteId: string) => {
  const templateQuery = useQuery(['templates', siteId], async () => {
    const offsiteTemplates = (await RestApi.get<ITemplate[]>(`/sites/${siteId}/templates/new`)).data.filter(
      p => p.channel === 'email',
    );

    const onsiteTemplates = (await RestApi.get<ITemplate[]>(`/sites/${siteId}/onsite/templates`)).data;

    return [...offsiteTemplates, ...onsiteTemplates];
  });

  return templateQuery;
};
